/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free random number generator. Pick a min, max and count (with or without duplicates), or generate version-4 UUIDs in bulk. Runs in your browser.`)
};

const es_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de números aleatorios gratuito. Elige un mín, máx y cantidad (con o sin duplicados), o genera UUID de versión 4 en masa. Se ejecuta en tu navegador.`)
};

const de_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zufallszahlengenerator. Wähle min, max und Anzahl (mit oder ohne Duplikate), oder generiere Version-4-UUIDs in großen Mengen. Läuft in deinem Browser.`)
};

const nl_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis generator voor willekeurige nummers. Kies een min, max en aantal (met of zonder duplicaten), of genereer versie-4 UUIDs in bulk. Werkt in uw browser.`)
};

const fr_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de nombres aléatoires gratuit. Choisissez un minimum, un maximum et un nombre (avec ou sans doublons), ou générez des UUID version 4 en masse. S'exécute dans votre navigateur.`)
};

const it_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore gratuito di numeri casuali. Scegli min, max e numero (con o senza duplicati), oppure genera UUID version-4 in massa. Viene eseguito nel tuo browser.`)
};

const pt_br2_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito de números aleatórios. Escolha um mín, máx e contagem (com ou sem duplicatas), ou gere UUIDs versão 4 em massa. Funciona no seu navegador.`)
};

const pt_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito de números aleatórios. Escolha um mín, máx e contagem (com ou sem duplicados), ou gere UUIDs de versão-4 em massa. Funciona no seu navegador.`)
};

const ja_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のランダム番号ジェネレータ。最小値と最大値とカウントを選択（重複あり/なし）、またはバージョン4のUUIDを一括生成します。ブラウザで実行可能です。`)
};

const zh_rg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的随机数生成器。设置最小值、最大值和数量（可选是否允许重复），或批量生成第4版UUID。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_meta_description", locale)
	if (locale === "en") return en_rg_meta_description(inputs)
	if (locale === "es") return es_rg_meta_description(inputs)
	if (locale === "de") return de_rg_meta_description(inputs)
	if (locale === "nl") return nl_rg_meta_description(inputs)
	if (locale === "fr") return fr_rg_meta_description(inputs)
	if (locale === "it") return it_rg_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_rg_meta_description(inputs)
	if (locale === "pt") return pt_rg_meta_description(inputs)
	if (locale === "ja") return ja_rg_meta_description(inputs)
	return zh_rg_meta_description(inputs)
};